import { IcArrowLeft, Text } from 'basic-ui-lib';
import { IMediaItem } from 'modules/media/interfaces/api';
import { BreadcrumbPath } from 'modules/media/services/hooks/useMediaExplorer';
import styled from 'styled-components';

interface BreadcrumbProps {
  path: BreadcrumbPath[];
  onBack: () => void;
  items: IMediaItem[];
}

export const Breadcrumb = ({
  path,
  onBack,
  items,
}: BreadcrumbProps) => {

  if (path.length === 0) return null;

  const current = path[path.length - 1];

  return (
    <Container>
      <button onClick={onBack} style={{ background: 'none', border: 'none' }} type='button'>
        <IcArrowLeft width={24} height={24} fill='#777D7C' />
      </button>
      <Text body_1 medium>
        {current.label} {items.length > 1 ? `(${items.length})` : ''}
      </Text>
    </Container>
  );
};


const Container = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  gap: 10px;
`;